import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d95abd98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choice-shop-table" }
const _hoisted_2 = { class: "choice-table-title flex-ter" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "express-content rel" }
const _hoisted_5 = { class: "flex-center" }
const _hoisted_6 = { class: "mr_5" }
const _hoisted_7 = { class: "el-dropdown-link" }
const _hoisted_8 = { class: "dropdown-content" }
const _hoisted_9 = { class: "checked" }
const _hoisted_10 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/checked_icon.png",
  alt: ""
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/ship_icon.png",
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_12 = { class: "checked" }
const _hoisted_13 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/checked_icon.png",
  alt: ""
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/air_icon.png",
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "choice-transport-tip flex-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/shopcart/transport_icon.png",
  alt: "",
  class: "tip-icon"
}, null, -1))
const _hoisted_17 = { class: "choice-tip flex-ter" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/notice_icon.png",
  alt: ""
}, null, -1))

import dayjs from 'dayjs'
import { t } from '@/plugins/i18n'
import ExpressFeeBtn from './ExpressFeeBtn.vue'
import Table from './Table.vue'
import { ref, onMounted, computed } from 'vue'
import { deleteSku } from '@/apis/shopcart'
import { confirmDeleteSku } from '@/util/useConfirm'
import { allIncludeExchangeRate, floatExchangeRate } from '@/util/useYan'
import { useStore } from 'vuex'
import ChangeAdt from '../ChangeAdt.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['list', 'checkMap', 'transportType', 'changeTransportType', 'totalAmount', 'choiceFn', 'normalDisabled', 'isTikTokShop2C'],
  emits: ['refresh'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()
const curShop = computed(() => store.state.route.curShop)
const choiceDropdownRef = ref()
// normalDisabled 选中代采商品时，choice禁止勾选


const handleDel = () => {
  if (Object.values(props.checkMap)?.length === 0) return
  confirmDeleteSku(
    () => {
      deleteSku({ cartIdList: Object.values(props.checkMap).map(v => v.cartId) }).then(() => {
        emits('refresh')
      })
    },
    () => { }
  )
}
const change = (type: number) => {
  choiceDropdownRef.value?.handleClose()
  props?.changeTransportType(type)
}
const showStatus = ref(true)
const isShowTip = computed(() => {
  const storage = JSON.parse(window.localStorage.getItem('SHOPCART_CHANGE_TRANSPORT') ?? '{}')
  const isOver = (storage[curShop.value]?.time ?? 0) < new Date().getTime()
  if (props.totalAmount?.totalPriceJPY >= 150000 && props.transportType === 2 && isOver) {
    return true
  }
  return false
})
const close = () => {
  const storage = JSON.parse(window.localStorage.getItem('SHOPCART_CHANGE_TRANSPORT') ?? '{}')
  storage[curShop.value] = {
    time: new Date(dayjs().format('YYYY-MM-DD 23:59:59')).getTime()
  }
  window.localStorage.setItem('SHOPCART_CHANGE_TRANSPORT', JSON.stringify(storage))
  showStatus.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('Choice商品')), 1),
      _createElementVNode("div", {
        class: "del-btn cursor-pt",
        onClick: handleDel
      }, _toDisplayString(_unref(t)('批量删除')), 1),
      _createVNode(ChangeAdt, {
        list: Object.values(__props.checkMap),
        onUpdate: _cache[0] || (_cache[0] = ($event: any) => (emits('refresh'))),
        choiceCost: true,
        noSpot: true
      }, null, 8, ["list"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('运输方式')) + "：" + _toDisplayString(__props.transportType === 1 ? _unref(t)('海运') : _unref(t)('空运')), 1),
          (__props.totalAmount?.totalPriceJPY >= 150000 || __props.totalAmount?.totalPriceJPY === 0)
            ? (_openBlock(), _createBlock(_component_el_dropdown, {
                key: 0,
                trigger: "click",
                "popper-class": "choice-shop-pop",
                ref: (_value, _refs) => {
                  _refs['choiceDropdownRef'] = _value
                  choiceDropdownRef.value = _value
                }
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["dropdown-item flex-ter", { active: __props.transportType === 1 }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (change(1)))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        (__props.transportType === 1)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_11,
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('海运')), 1)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["dropdown-item flex-ter", { active: __props.transportType === 2 }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (change(2)))
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        (__props.transportType === 2)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_14,
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('空运')), 1)
                    ], 2)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('请选择')) + "> ", 1)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ]),
        (_unref(isShowTip) && showStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", null, _toDisplayString(_unref(t)('您的订单金额大于15万日元，选择船运物流方式更优惠')), 1),
              _createElementVNode("img", {
                src: "https://static-s.theckb.com/BusinessMarket/Client/choice/shopcart/close_icon.png",
                alt: "",
                class: "close-icon",
                onClick: close
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ExpressFeeBtn)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("span", null, "※THE CKBの為替レートは、三菱UFJ銀行の毎月第一営業日のTTSレート＋" + _toDisplayString(_unref(floatExchangeRate)) + "を基準に日本円に換算しています。 (THE CKBの対応レート：" + _toDisplayString(_unref(allIncludeExchangeRate)) + " ,お見積り有効期限： " + _toDisplayString(_unref(dayjs)().endOf('month').format('YYYY/MM/DD')) + ")", 1)
    ]),
    _createVNode(Table, {
      list: __props.list,
      choiceFn: __props.choiceFn,
      isTikTokShop2C: __props.isTikTokShop2C,
      normalDisabled: __props.normalDisabled,
      onRefresh: _cache[3] || (_cache[3] = ($event: any) => (emits('refresh'))),
      transportType: __props.transportType
    }, null, 8, ["list", "choiceFn", "isTikTokShop2C", "normalDisabled", "transportType"])
  ]))
}
}

})